import { useCallback } from 'react';

import { Button } from '@/components/design-system/Button';
import { Input } from '@/components/design-system/input';
import { cn } from '@/utils/cn';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface GridSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const GridSearchInput = ({ value, onChange, className }: GridSearchInputProps) => {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  const handleClear = useCallback(() => {
    onChange('');
  }, [onChange]);

  const hasValue = value.length >= 2;

  return (
    <div className={cn('relative max-w-96', className)}>
      <SearchOutlined className="text-typography-500! pointer-events-none absolute top-1/2 left-2.5 -translate-y-1/2 text-sm" />
      <Input
        placeholder={t('label.search')}
        value={value}
        onChange={handleChange}
        size="md"
        status={hasValue ? 'warning' : 'default'}
        className={cn(
          'w-full pl-8',
          hasValue && 'bg-warning-100 border-warning-400 hover:border-warning-600 focus-visible:border-warning-500 pr-8'
        )}
        data-testid="grid-search-input"
      />
      {hasValue && (
        <Button
          type="button"
          size="condensed"
          onClick={handleClear}
          className="[&_svg]:text-typography-500 hover:[&_svg]:text-typography-900 absolute top-1/2 right-3 h-auto w-auto -translate-y-1/2 cursor-pointer border-none bg-transparent p-0 text-xs hover:border-none hover:bg-transparent"
        >
          <CloseOutlined />
        </Button>
      )}
    </div>
  );
};
